import { createContext, useContext } from "react";

export const WidgetContent = createContext(null);

export const useWidgetContent = () => {
  const data = useContext(WidgetContent);

  if (data === null) {
    throw new Error(
      "Consumer of WidgetContent should be wrapped by WidgetProvider"
    );
  }

  return data;
};
